<template>
  <Row style="height: 100%">
    <Col style="background: #fff; height: 100%" span="4">
      <Card style="height: 100%">
        <div class="search-inp">
          <Input :placeholder="$t('keyword')" style="width: 84%" />
          <Button
            style="margin-left: 10px"
            type="success"
            icon="md-add"
            @click.stop="addClass"
          ></Button>
        </div>

        <Menu style="width: 100%; height: calc(100 - 42px)">
          <template v-for="(cl, clIdx) in classList">
            <Submenu v-if="cl.children" :key="cl.id + cl.title" :name="cl.id">
              <template #title>
                <!-- <Icon type="ios-paper" /> -->
                <Button
                  v-for="(item, index) in btnList"
                  :key="index"
                  style="margin-right: 5px"
                  :type="item.type"
                  :icon="item.icon"
                  size="small"
                  @click.stop="classFun(item.event, cl)"
                ></Button>
                {{ cl.title }}
              </template>
              <MenuItem
                v-for="(ch, chIdx) in cl.children"
                :key="chIdx"
                :name="ch.id"
              >
                <template v-for="(item, index) in btnList">
                  <Button
                    v-if="index > 0"
                    :key="index"
                    style="margin-right: 5px"
                    :type="item.type"
                    :icon="item.icon"
                    size="small"
                    @click.stop="classFun(item.event, cl)"
                  ></Button>
                </template>
                {{ ch.title }}
              </MenuItem>
            </Submenu>
            <MenuItem v-else :key="clIdx + cl.title" :name="cl.id">
              <template v-for="(item, index) in btnList">
                <Button
                  style="margin-right: 5px"
                  :type="item.type"
                  :icon="item.icon"
                  size="small"
                  @click.stop="classFun(item.event, cl)"
                ></Button>
              </template>
              {{ cl.title }}
            </MenuItem>
          </template>
        </Menu>
      </Card>
    </Col>
    <Col style="height: 100%" span="20">
      <cTable
        ref="table"
        :fields="fields"
        :header="header"
        :methods="methods"
        :modals="modals"
        :config="config"
      ></cTable>
    </Col>
  </Row>
</template>

<script>
import {
  getDocumentList,
  addDocument,
  editDocument,
  deleteDocument,
} from "@/api/documentManagement/documentList";
import {
  getClassList,
  addClass,
  editClass,
  deleteClass,
} from "@/api/documentManagement/documentClass";

import cTable from "@/base/common/index";
export default {
  name: "documentList",
  components: {
    cTable,
  },
  created() {
    this.getClassListFun();
  },
  methods: {
    // 获取分类列表
    getClassListFun() {
      getClassList().then((res) => {
        this.classList = res.data.payload;
      });
    },
    // 文档分类事件
    classFun(type, obj) {
      console.log(type);
      switch (type) {
        case "add":
          this.addClass(obj);
          break;
        case "edit":
          this.editClass(obj);
          break;
        case "del":
          this.deleteClass(obj);
          break;
        default:
          break;
      }
    },
    addClass(obj) {
      console.log(obj);
      // let str = obj.id
      this.$refs["table"].getModal("add").open(obj, function () {
        this.setTitle(this.$t("add") + this.$t("documentClass"));
      });
    },
    editClass(id) {
      this.$refs["table"].getModal("add").open(null, function () {
        this.setTitle(this.$t("modify") + this.$t("documentClass"));
      });
    },
    deleteClass(id) {
      this.$Modal.confirm({
        title: this.$t("delete") + this.$t("documentClass"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          this.handleRequestMethods("deleteClass", row.id, true, true).then(
            (res) => {
              this.getModal("remarksList").getList();
              this.getList();
            }
          );
        },
      });
    },
  },
  data() {
    return {
      classList: [],
      btnList: [
        {
          type: "success",
          icon: "md-add",
          event: "add",
        },
        {
          type: "warning",
          icon: "ios-create-outline",
          event: "edit",
        },
        {
          type: "error",
          icon: "md-trash",
          event: "del",
        },
      ],
      methods: {
        list: getDocumentList,
        addDocument,
        editDocument,
        deleteDocument,
        getClassList,
        addClass,
        editClass,
        deleteClass,
      },
      config: {
        height: 630,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              // contraband_code: [
              //   {
              //     required: true,
              //     message: "Code cannot be empty",
              //     trigger: "blur"
              //   },
              //   {
              //     type: "string",
              //     min: 3,
              //     max: 5,
              //     message: "Please enter minimum length 3 and maximum length 5",
              //     trigger: "blur"
              //   }
              // ],
              // contraband_description: [
              //   {
              //     required: true,
              //     message: "Desc cannot be empty",
              //     trigger: "blur"
              //   },
              //   {
              //     type: "string",
              //     min: 3,
              //     max: 155,
              //     message:
              //       "Please enter minimum length 3 and maximum length 155",
              //     trigger: "blur"
              //   }
              // ]
            },
          },
          grid: [{ contraband_code: 24 }, { contraband_description: 24 }],
          fields: [
            {
              name: () => this.$t("contraband_code"),
              key: "contraband_code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("contraband_code");
              },
            },
            {
              name: () => this.$t("contraband_description"),
              key: "contraband_description",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("contraband_description");
              },
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          },
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 155,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("contraband_code"),
          key: "contraband_code",
          align: "center",
        },
        {
          name: () => this.$t("contraband_description"),
          key: "contraband_description",
          align: "center",
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 156,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 157,
              // bind: {
              //   type: "error"
              // }
            },
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.search-inp {
  // margin: 0px auto 0;
  // width: 90%;
  box-sizing: border-box;
  display: flex;
  justify-items: center;
  align-items: center;
}
.ivu-menu-vertical.ivu-menu-light:after {
  display: none;
}
</style>
